export default "__VITE_ASSET__e003f639__"